export type TenantStatus = 'ACTIVE' | 'SUSPENDED' | 'CLOSED';

export interface TenantView {
  id: number;
  slug: string;
  name: string;
  status: TenantStatus;
}

export interface CreateTenantRequest {
  slug: string;
  name: string;
}

/** PATCH /operator/tenants/{id} — 至少填一项；空字符串视为不传该字段。 */
export interface UpdateTenantRequest {
  name?: string;
  slug?: string;
}

/** Mirrors `com.mall.auth.AdminAccountCredentials`. Cleartext password shown ONCE. */
export interface AdminAccountCredentials {
  username: string;
  clearTextPassword: string;
}

/** Response of `POST /operator/tenants` — tenant + initial admin credentials. */
export interface TenantBootstrapView {
  tenant: TenantView;
  initialAdmin: AdminAccountCredentials;
}

export interface ResetAdminPasswordRequest {
  /** null/blank → server generates a strong random password. */
  password: string | null;
}

export const TENANT_STATUS_LABEL: Record<TenantStatus, string> = {
  ACTIVE: '正常',
  SUSPENDED: '已禁用',
  CLOSED: '关闭',
};

export const TENANT_STATUS_COLOR: Record<TenantStatus, string> = {
  ACTIVE: 'green',
  SUSPENDED: 'orange',
  CLOSED: 'red',
};
